export default function(data) {
  var self = this;

  self.search_enabled = true;
  self.paginator = ko.observable();
  self.searchQuery = ko.observable();
  self.allow_search_on_blur = true;
  self.coupons = ko.observableArray();
  
  self.searchQuery.subscribe(function() {
    self.filterChanged();
  });

  self.bindData = function(data) {
    self.coupons(data.coupons);
    self.paginator(data.paginator);
  };

  self.filterChanged = function() {
    self.couponListing();
  };

  self.buildQuery = function(url) {
    var query = {};
    if (typeof url !== 'undefined') {
      query.page = Kadenze.Util.getURLParams(url.replace('/admin/membership_coupons', '')).page;
    }

    if (self.searchQuery()) {
      query.q = self.searchQuery();
    }
    return query;
  };

  self.couponListing = function(url) {
    Kadenze.UIUtil.showLoadingIndicator(self.$el, null, 'fixed');

    url = Kadenze.Routes.admin_membership_coupons_path(self.buildQuery(url));
    var req = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url
    });

    req.done(function(coupons) {
      self.bindData(coupons.coupons);
    });

    req.always(function(data) {
      Kadenze.UIUtil.hideLoadingIndicator(self.$el);
    });
  };

  self.enableSearch = function() {
    $('.select-box').addClass('hide');
  };

  self.copyMessage = function(coupon, url) {
    var inp = document.createElement('input');
    document.body.appendChild(inp);
    inp.value = url.replace('coupon', coupon.code);
    inp.select();
    document.execCommand('copy', false);
    inp.remove();

    new Kadenze.Notice.info({
      message: 'Redemption URL copied to clipboard',
      dismissable: false,
      timeout: 1000
    });
  };

  self.init = function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.couponListing);
  };

  const __construct = function(that) {
    console.log('constructor called for AdminCouponListing');
    that.bindData(data);
  }(this);
}

